import styled from 'styled-components';

import colors from 'styles/theme/colors';
import InfoIconOutline from 'svg/InfoIconOutline';

type TimingExplainerProps = {
  jobType: 'summary' | 'comparison';
};

const TimingExplainer = ({ jobType }: TimingExplainerProps) => {
  return (
    <Container>
      <InfoIconOutline />
      <div>
        <span>Generating your {jobType} may take a few minutes.</span> The {jobType} will continue to generate in the
        background if you navigate away.
      </div>
    </Container>
  );
};

export default TimingExplainer;

const Container = styled.div`
  margin-top: 40px;
  display: flex;
  align-items: center;
  border: 1px solid ${colors.purple10};
  border-radius: 8px;
  padding: 20px;
  font-size: 12px;
  background: linear-gradient(270deg, ${colors.purple5} 0%, ${colors.purple10} 100%);

  span {
    font-weight: 500;
  }

  svg {
    margin-right: 16px;
    flex-shrink: 0;
  }
`;
